import React from 'react';

import { Link } from 'react-router-dom';

import CopyableField from '../Common/CopyableField';

const PromoLink = ({ codeName }: { codeName: string }) => {
  return (
    <CopyableField
      value={codeName}
      label={
        <Link to={`/promos/code/${codeName}`} target="_blank" rel="noreferrer" color="inherit">
          {codeName}
        </Link>
      }
    />
  );
};

export default PromoLink;
